import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["commissionTotal", "commissionTotalHidden", "percentageTemplate", "addPercentage", "contractNumber", "otherPercent", "otherPartner"];

  percentageFields = 2;

  calculate(event) {
    const el = event.target;
    this.calculateRowCommission(el);
  }

  async forCalculateCustom(lenght){
    const current_partner_id = document.getElementById("current_partner_id").value;
    const response_for_current = await fetch(`/partners/${current_partner_id}.json`).then(response => response.json());
    const partner_id = this.otherPartnerTargets[lenght].value;
    const response = await fetch(`/partners/${current_partner_id}.json?partner_id_for_commission=${partner_id}`).then(response => response.json());
    const contractNumber = this.contractNumberTargets[lenght];
    const words = contractNumber.value.split("-");
    const contract_number = words[0].toUpperCase();
    const current_commissions = {
      "NE": response_for_current.commission,
      "NJ": response_for_current.commission,
      "NB": response_for_current.commission,
      "NP": response_for_current.bundle_commission,
      "NPS": response_for_current.bundle_commission,
      "NNN": response_for_current.nnn_commission,
      "NVM": response_for_current.nvm_commission,
      "NLP": response_for_current.nlp_commission
    };
    const commissions = {
      "NE": response.commission,
      "NJ": response.commission,
      "NB": response.commission,
      "NP": response.bundle_commission,
      "NPS": response.bundle_commission,
      "NNN": response.nnn_commission,
      "NVM": response.nvm_commission,
      "NLP": response.nlp_commission
    };
    const commissionValue = parseFloat(current_commissions[contract_number]) - parseFloat(commissions[contract_number]);
    this.otherPercentTargets[lenght].value = commissionValue.toFixed(2);
    return commissionValue.toFixed(2) / 100;
  }
  async calculateCustom(event) {
    const el = event.target;
    const inputRow = el.closest(".custom_calculationform");
    const amountValue = inputRow.getElementsByClassName("cust-amount")[0];
    const amount = amountValue.value ? amountValue.value : 0;
    let commission = 0;
    const regex = /\d+/g;
    const name_filed= el.name;
    const number_line = parseInt(name_filed.match(regex));
    const lenght = number_line - 1;
    if (this.otherPartnerTargets[lenght].value && this.otherPartnerTargets[lenght].value !== 0) {
      const percentage = await this.forCalculateCustom(lenght);
      commission = (amount * percentage).toFixed(2);
    } else if (!this.otherPartnerTargets[lenght].value && this.otherPercentTargets[lenght].value && this.otherPercentTargets[lenght].value !== 0) {
      const percentage = parseFloat(this.otherPercentTargets[lenght].value) / 100;
      commission = (amount * percentage).toFixed(2);
    } else {
      commission = amount;
    }
    inputRow.querySelector(".comm").innerText = commission;
    inputRow.querySelector(".comm_hidden").value = commission;
    this.calculateCommission();
  }

  calculateRowCommission(el) {
    let percentage = parseFloat(el.dataset.percentage) / 100;
    let amount = el.value;
    let target = "#" + el.dataset.targetname + "form";
    let commission = (amount * percentage).toFixed(2);
    let form = el.closest(target);

    form.querySelector(".comm").innerText = commission;
    form.querySelector(".comm_hidden").value = commission;
    this.calculateCommission();
  }

  setOtherPercentage(event) {
    const el = event.target;
    const percentage = el.value;
    const input = document.getElementById("commission_settlement_other_commission");
    input.dataset.percentage = percentage;
    this.calculateRowCommission(input);
  }

  calculateCommission() {
    let self = this;
    this.commissionTotal = 0.00;
    let commissions = document.querySelectorAll(".comm_hidden");
    commissions.forEach(function(el) {
      self.commissionTotal += parseFloat(el.value);
    });
    this.commissionTotalTarget.innerText = this.commissionTotal.toFixed(2);
    this.commissionTotalHiddenTarget.value = this.commissionTotal.toFixed(2);
  }

  async partnerSearch(event) {
    let el = event.target;
    let partner_id = el.value;
    let response = await fetch(`/admin/accounting/partner_search.json?partner_id=${partner_id}`);
    let partners = await response.json();

    let datalist = document.getElementById("partners");
    this.removeAllChildNodes(datalist);

    partners.forEach(function(partner) {
      const option = document.createElement("option");
      const text = document.createTextNode(`${partner.partner_id} ${partner.name}`);
      const valueAttr = document.createAttribute("value");
      valueAttr.value = partner.partner_id;
      option.setAttributeNode(valueAttr);
      option.append(text);
      datalist.appendChild(option);
    });
  }

  removeAllChildNodes(parent) {
    while (parent.firstChild) {
      parent.removeChild(parent.firstChild);
    }
  }

  addCustomPercentage(e) {
    e.preventDefault();
    const index = this.percentageFields;
    const content = this.percentageTemplateTarget.innerHTML
      .replace(
        /_0_/g,
        `_${index}_`
      )
      .replace(
        /\]\[0\]\[/g,
        `][${index}][`
      );
    this.addPercentageTarget.insertAdjacentHTML("beforebegin", content);
    this.percentageFields++;
  }
}